export default __webpack_public_path__ + "static/media/heart.e48a2ea2.png";